import React, { useEffect, useState } from "react";
import { CardProps } from "./InfoCard";
import PillButton from "../pillButton/PillButton";
import { cardData, filterData } from "../../utils/DataUtils";
import DatesModal from "../../sections/modals/dates/DatesModal";
// import { cardPlusData, cardVKUData } from "../../data/staticData";
import vkuDataFile from "../../data/vkuData.json";
import plusDataFile from "../../data/plusData.json";
import DetailsVKUModal from "../../sections/modals/details/DetailsVKUModal";
import DetailsPlusModal from "../../sections/modals/details/DetailsPlusModal";

const InfoCardContent = ({
  type,
  logo,
  title,
  content,
  subContent,
}: CardProps) => {
  const [vkuData, setVkuData] = useState<cardData[]>(vkuDataFile);
  const [plusData, setPlusData] = useState<cardData[]>(plusDataFile);
  const [cardDataValues, setCardDataValues] = useState<cardData[]>(
    type === "vku" ? vkuData : plusData
  );
  const [showDetailsVKUModal, setShowDetailsVKUModal] = useState(false);
  const [showDetailsPlusModal, setShowDetailsPlusModal] = useState(false);
  const [showDatesModal, setShowDatesModal] = useState(false);
  // const [selectedCard, setSelectedCard] = useState();

  const toggleShowDatesModal = () => setShowDatesModal(!showDatesModal);
  const toggleShowDetailsVKUModal = () =>
    setShowDetailsVKUModal(!showDetailsVKUModal);
  const toggleShowDetailsPlusModal = () =>
    setShowDetailsPlusModal(!showDetailsPlusModal);

  const handleDropdown = (selectedDay: Set<string>[]) => {
    const dataSeleced = type === "vku" ? vkuData : plusData;

    const filteredData = filterData(selectedDay, dataSeleced);
    setCardDataValues(filteredData);
  };

  useEffect(() => {
    const fetchVKU = fetch(
      "https://www.fahrschul-kurse.ch/data/fetchVKUData.php"
    ).then((res) => {
      if (!res.ok) throw new Error("Failed to fetch vku data");
      return res.json();
    });

    const fetchPlus = fetch(
      "https://www.fahrschul-kurse.ch/data/fetchPlusData.php"
    ).then((res) => {
      if (!res.ok) throw new Error("Failed to fetch notheilfer data");
      return res.json();
    });

    Promise.all([fetchVKU, fetchPlus])
      .then(([vkuRes, plusRes]) => {
        setVkuData(vkuRes);
        setPlusData(plusRes);
        // console.log("✅ Both datasets fetched successfully");
      })
      .catch((error) => {
        console.error("❌ Fetch failed:", error.message);
      });
  }, []);

  return (
    <div className="w-full pl-6 mb-8">
      <DatesModal
        type={type}
        showDatesModal={showDatesModal}
        cardDataValues={cardDataValues}
        handleDropdown={handleDropdown}
        onToggleDatesModal={toggleShowDatesModal}
      />

      <DetailsVKUModal
        showDetailsVKUModal={showDetailsVKUModal}
        onToggleDetailsVKUModal={toggleShowDetailsVKUModal}
      />
      <DetailsPlusModal
        showDetailsPlusModal={showDetailsPlusModal}
        onToggleDetailsPlusModal={toggleShowDetailsPlusModal}
      />
      <div className="flex justify-between items-center mt-6 pl-1 pr-8">
        <div className="font-title text-light-gray">{title}</div>
        <div
          className={`flex justify-start items-center font-title h-16 ${
            type === "plus"
              ? "font-bold text-9xl text-red-600 pt-4"
              : "text-dark-blue text-5xl"
          }`}
        >
          {logo}
        </div>
      </div>
      <div className="mr-20 font-content text-light-gray">{content}</div>
      <div className="font-content text-sm text-light-gray pt-6">
        <strong>DAUER & KOSTEN</strong>
        <p>{subContent}</p>
        <br />
      </div>
      <div className="font-title text-light-gray pt-1">
        Bitte beachte, dass diese Anmeldung verbindlich ist und bei einem
        Nichterscheinen die Verrechnung vom ganzen Kursgeld zur Folge hat.
      </div>
      <div className=" w-full flex flex-row justify-around max-[450px]:flex-col max-[450px]:items-start">
        <button
          onClick={() =>
            type === "vku"
              ? toggleShowDetailsVKUModal()
              : toggleShowDetailsPlusModal()
          }
          className="mt-2"
        >
          <PillButton
            text="Einzelheiten"
            className="!bg-gray-green hover:!bg-hover-gray-green"
          />
        </button>
        <button onClick={toggleShowDatesModal} className="mt-2">
          <PillButton text="Anmeldung Online" className="max-md:px-6" />
        </button>
      </div>
    </div>
  );
};

export default InfoCardContent;
